import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const SidebarLeftLayout = ({
  topbar,
  sidebar,
  sidebarWidth,
}: SidebarLeftLayoutProps) => {
  return (
    <Box height="100vh" overflow="hidden">
      <Box
        height="60px"
        backgroundColor="gray.200"
        position="fixed"
        width="100%"
        zIndex="docked"
      >
        {topbar}
      </Box>
      <Flex direction="row" pt="100px">
        <Box backgroundColor="gray.300" height="100%" position="fixed">
          {sidebar}
        </Box>
        <Box
          ml={sidebarWidth}
          pt="4"
          pr="4"
          p={5}
          overflowY="auto"
          height="calc(100vh - 115px)"
          flex="1"
        >
          <Outlet />
        </Box>
      </Flex>
    </Box>
  );
};

export default SidebarLeftLayout;

interface SidebarLeftLayoutProps {
  topbar: React.ReactNode;
  sidebar: React.ReactNode;
  sidebarWidth: number;
}
